/**
 * Where the car actually stops.
 *
 * A station's pin is the middle of its platforms, which underground is somewhere no car can reach
 * — and at Civic Center it sits on Market Street, which private cars may not drive. Routing to it
 * therefore prices a journey nobody makes. What matters to a drive time is the curb.
 *
 * Civic Center's boarding geofence also uses this point. The station pin is about 100 m northeast
 * of the loading zone, leaving the actual handoff near the edge of a 125 m station-centered fence.
 */

import type { Coordinates } from "../shared/types";

const DROP_OFF: Record<string, Coordinates> = {
	// The loading zone off Hyde.
	CIVC: { lat: 37.779111, lon: -122.415 },
};

/** The curb for this station, or nothing when it has no answer better than its own pin. */
export function dropOffCoordinates(stationId: string): Coordinates | null {
	return DROP_OFF[stationId] ?? null;
}

/** The curb where one is known, otherwise the station itself. */
export function boardingGeofenceCoordinates(stationId: string, station: Coordinates): Coordinates {
	return dropOffCoordinates(stationId) ?? station;
}
